import { palette, shape } from "@src/core/styles";
import styled from "styled-components";

export const MenuWrapper = styled.div`
  background-color: ${palette.colors.surface};
  padding: 8px 0;
  width: 200px;
  border-radius: ${shape.rounding.M};
  box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.15),
    0px 1px 2px 0px rgba(0, 0, 0, 0.3);
`;

export const MenuList = styled.div``;

export const MenuItem = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: all ease 0.1s;

  &:hover {
    background-color: rgba(26, 28, 25, 0.08);
  }
`;
